export const gitTag = {
    version:'317b1120eb1f8337aec2d254149719ddddb19377-317b112',
    buildTime:'Mon Jun 30 2025 18:49:04 GMT+0530 (India Standard Time)',
    commitId: '317b112'
};
